interface VideoPlayerProps {
  src: string;
  videoRef: React.RefObject<HTMLVideoElement>;
}

export function VideoPlayer({ src, videoRef }: VideoPlayerProps) {
  return (
    <div className="overflow-hidden md:rounded-2xl">
      <div className="aspect-video">
        <video
          ref={videoRef}
          src={src}
          preload="auto"
          controls
          controlsList="nodownload"
          className="h-full w-full"
        />
      </div>
    </div>
  );
}
